<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoJobs">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoJobs">
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="itensPaginados.content"
                dataKey="id"
                [rows]="itensPaginados.size"
                [loading]="loading"
                [rowHover]="true"
                [paginator]="true"
                [totalRecords]="itensPaginados.totalElements"
                [lazy]="true"
                (onLazyLoad)="onLazyLoad($event)"
                [showCurrentPageReport]="true"
                responsiveLayout="scroll"
                styleClass=" p-datatable-sm"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="flex flex-column md:flex-row">
                            <div class="p-fluid md:w-12rem md:mr-2">
                                <label>Data Inicial</label>
                                <p-calendar
                                    [readonlyInput]="true"
                                    [showIcon]="true"
                                    dateFormat="dd/mm/yy"
                                    [showButtonBar]="true"
                                    ngModel
                                    [(ngModel)]="dataFiltroInicio"
                                    styleClass="p-button-outlined"
                                    appendTo="body"
                                    placeholder="Selecione"
                                    (ngModelChange)="filtrarPorData()"
                                ></p-calendar>
                            </div>
                            <div class="p-fluid md:w-12rem md:mr-2">
                                <label>Data Final</label>
                                <p-calendar
                                    [readonlyInput]="true"
                                    [showIcon]="true"
                                    dateFormat="dd/mm/yy"
                                    [showButtonBar]="true"
                                    ngModel
                                    [(ngModel)]="dataFiltroFim"
                                    appendTo="body"
                                    placeholder="Selecione"
                                    (ngModelChange)="filtrarPorData()"
                                ></p-calendar>
                            </div>
                            <div class="p-fluid w-full sm:w-21rem">
                                <label for="">Job</label>
                                <p-dropdown
                                    [options]="opcoesFiltroJobs"
                                    optionLabel="label"
                                    optionValue="value"
                                    [filter]="false"
                                    emptyFilterMessage="Nenhum registro"
                                    [(ngModel)]="filtroJobSelecionado"
                                    (ngModelChange)="listar()"
                                    appendTo="body"
                                ></p-dropdown>
                            </div>
                        </div>
                        <span class="mt-2 sm:mt-4">
                            <button
                                pButton
                                class="p-button-outlined"
                                icon="pi pi-filter-slash"
                                pTooltip="Limpar Filtros"
                                (click)="limpar(dt1)"
                            ></button>
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="dia">
                            Dia
                            <p-sortIcon field="dia"></p-sortIcon>
                        </th>
                        <th pSortableColumn="nome">
                            Nome
                            <p-sortIcon field="nome"></p-sortIcon>
                        </th>
                        <th>Status Execução</th>
                        <th style="text-align: center">
                            <div>Ações</div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.dia | date: "dd/MM/yyy" }}
                        </td>
                        <td>
                            {{ item.nome }}
                        </td>
                        <td>
                            <span
                                *ngIf="item.statusExecucao === 'NÃO RODOU'"
                                class="product-badge bg-red-600 admihair-text-white"
                            >
                                {{ item.statusExecucao }}
                            </span>
                            <span
                                *ngIf="item.statusExecucao === 'OK'"
                                class="product-badge bg-green-600 admihair-text-white"
                            >
                                {{ item.statusExecucao }}
                            </span>
                            <span
                                *ngIf="item.statusExecucao === 'INICIADO SEM FINALIZAR'"
                                class="product-badge bg-orange-600 admihair-text-white"
                            >
                                {{ item.statusExecucao }}
                            </span>
                        </td>

                        <td style="text-align: center">
                            <div>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Detalhes"
                                    icon="pi pi-eye"
                                    class="p-button-info mr-2"
                                    (click)="abrirDialogDetalhe(item)"
                                ></button>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Rodar novamente"
                                    [icon]="item.isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-play'"
                                    [disabled]="item.isLoading"
                                    class="p-button-success"
                                    (click)="executar(item)"
                                ></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando grupos. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<p-dialog
    #dialogDetalheJob
    [(visible)]="exibirDialogDetalheJob"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '50rem' }"
    [modal]="true"
    [closable]="true"
>
    <ng-template pTemplate="header">
        <span class="text-900 font-semibold text-xl">
            Job - {{ monitoramentoJobSelecionado?.nome }} -
            <span
                *ngIf="monitoramentoJobSelecionado?.statusExecucao === 'NÃO RODOU'"
                class="ml-1 product-badge bg-red-600 admihair-text-white"
            >
                NÃO RODOU
            </span>
            <span
                *ngIf="monitoramentoJobSelecionado?.statusExecucao === 'OK'"
                class="ml-1 product-badge bg-green-600 admihair-text-white"
            >
                OK
            </span>
        </span>
    </ng-template>

    <ng-template pTemplate="content">
        <div class="grid mt-1">
            <div class="col-12">
                <p-table
                    #dt2
                    [value]="listaJobsDialog"
                    dataKey="id"
                    [rows]="10"
                    [loading]="loadingJobsDialog"
                    [rowHover]="true"
                    [paginator]="true"
                    responsiveLayout="scroll"
                    styleClass=" p-datatable-sm"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Data</th>
                            <th>Nome</th>
                            <th>Status</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                {{ item.data | dateWithMillis }}
                            </td>
                            <td>
                                {{ item.nome }}
                            </td>
                            <td>
                                {{ item.status }}
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7">Nenhum registro encontrado.</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loadingbody">
                        <tr>
                            <td colspan="7">Carregando grupos. Por favor aguarde.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-template>
</p-dialog>
